import { render, staticRenderFns } from "./AnnotationsList.vue?vue&type=template&id=c458f8d8&scoped=true&"
import script from "./AnnotationsList.vue?vue&type=script&lang=js&"
export * from "./AnnotationsList.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationsList.vue?vue&type=style&index=0&id=c458f8d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c458f8d8",
  null
  
)

export default component.exports